import { render } from "./registrationParent.vue?vue&type=template&id=b2e89222&scoped=true"
import script from "./registrationParent.vue?vue&type=script&lang=js"
export * from "./registrationParent.vue?vue&type=script&lang=js"

import "./registrationParent.vue?vue&type=style&index=0&id=b2e89222&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e89222"]])

export default __exports__